export interface ProjectNewForm {
  code: string;
  name: string;
  clientName: string;
  location: string;
  projectType: string;
  statusCode: string;
  startDate: string;
  endDate: string;
  contractAmount: number;
  budgetAmount: number;
  description: string;
  pmUserId: string;
  siteManagerUserId: string;
  // Metadata fields
  thumbnail: string;
  attachments: string[];
  teamIds: string[];
  managementUnit: string;
  duration: string;
  contractType: string;
  priority: string;
  note: string;
}

export const defaultNewProject: ProjectNewForm = {
  code: '',
  name: '',
  clientName: '',
  location: '',
  projectType: 'construction',
  statusCode: 'planning',
  startDate: '',
  endDate: '',
  contractAmount: 0,
  budgetAmount: 0,
  description: '',
  pmUserId: '',
  siteManagerUserId: '',
  thumbnail: '',
  attachments: [],
  teamIds: [],
  managementUnit: '',
  duration: '',
  contractType: '',
  priority: 'medium',
  note: '',
};
